<template>
  <div class="document-upload-component" v-bind:class="{loaded}">
    <UploadDraggerComponent
        ref="uploadDragger"
        :multiple="true"
        :upload="handleFileUpload"
        :filter="handleFilter"
        @change="handleChange"
        v-on:updated-document="onUpdatedDocument"
        :has-error="hasError"
        v-if="loaded"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox"/>
      </p>
      <p class="ant-upload-text">
        Klik hier of sleep het bestand naar dit gebied om het te uploaden
      </p>
      <p class="ant-upload-hint">
        Upload meerdere bestanden tegelijk.
      </p>
    </UploadDraggerComponent>

    <div v-else>
      <Skeleton :loading="true" style="width: 100%; display: block; margin-bottom: 15px;" height="168px"></Skeleton>
    </div>
  </div>
</template>
<script>
import documentApi from '~/api/document';
import customerApi from '~/api/customer';
import attachableCategoryApi from '~/api/attachable_category';
import UploadDraggerComponent from './UploadDraggerComponent';
import {Skeleton} from 'vue-loading-skeleton'

export default {
  name: "DocumentUploadComponent",
  props: {
    attachableCategoryId: {
      type: [String, Number],
      required: true
    },
    customerId: {
      type: [String, Number],
      default: null,
      required: false
    },
    hasAttachableType: {
      type: [String, Number],
      default: null,
      required: false
    },
    hasAttachableId: {
      type: [String, Number],
      default: null,
      required: false
    },
  },
  components: {
    UploadDraggerComponent,
    Skeleton
  },
  data() {
    return {
      data: [],
      searchResults: [],
      selectedValues: [],
      fetching: false,
      loaded: false,
      attachableCategory: null,
      customer: null,
      hasError: false,
    };
  },
  computed: {},
  methods: {
    handleChange(info) {
      const status = info.file.status;

      if (status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    handleFileUpload(params) {
      let file = params.file,
          extension = file.name.replace(/^.+\.([^.]+)$/, '$1');

      documentApi.create(this.customer, this.attachableCategory, this.hasAttachableType, this.hasAttachableId, file.name, file.type, extension, file, params.onProgress).then(response => {
        documentApi.find(response.data.id).then(response => {
          params.onSuccess(response.data);
          this.$emit('created-document', response.data);
        }).catch(error => {
          throw error;
        });
      }).catch(error => {
        params.onError(error);
      });
    },
    handleFilter(file) {
      // TODO: filter invalid files, throw error on failure and display message
      return true;
    },
    onUpdatedDocument(document) {
      this.$emit('updated-document', document);
    },
    clearFiles() {
      this.$refs.uploadDragger.clearFiles();
    },
    initCustomer() {
      return new Promise((resolve, reject) => {
        if (this.customerId !== null) {
          return customerApi.find(this.customerId)
              .then(response => {
                this.customer = response.data;
                resolve();
              }).catch(reject)
        } else {
          resolve()
        }
      })
    }
  },
  created() {
    Promise.all([
      attachableCategoryApi.find(this.attachableCategoryId)
          .then(response => {
            this.attachableCategory = response.data;
          }),
      this.initCustomer()
    ]).then(() => {
    }).catch(() => {
      this.hasError = true;
    }).finally(() => {
      this.loaded = true;
    });
  }
}
</script>

<style scoped>
.ant-select-selection__choice__remove {
  margin-top: .5rem;
}

.d-center {
  display: flex;
  align-items: center;
}

.selected .ant-avatar {
  height: 25px;
  width: 25px;
}

.selected .agency-badge {
  padding: 1rem 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}

.v-select-loader {
  text-align: center;
  color: #bbbbbb;
}

</style>
